import { render, staticRenderFns } from "./UnidadeRegionalDetalhe.vue?vue&type=template&id=2394dd9c"
import script from "./UnidadeRegionalDetalhe.vue?vue&type=script&lang=js"
export * from "./UnidadeRegionalDetalhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports